import React, { useEffect, useRef, useState } from "react";
import { Form, Input, Spin, Divider } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../features/save/saveSlice";
import BreadCrumb from "../../../layout/BreadCrumb";
import dayjs from "dayjs";
import { normalizeDateToLocalYear } from "../../../utils";
import Details from "./scheme-add/Details";
import Operations from "./scheme-add/Operations";
import LandUse from "./scheme-add/LandUse";
import Water from "./scheme-add/Water";

const { TextArea } = Input;
const AsalAdd = ({ prodd }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { saving } = useSelector((state) => state.save);

  const { activeObjSchemes } = useSelector((state) => ({
    activeObjSchemes: state.obj.activeObj["asalSchemes"],
  }));

  const dispatch = useDispatch();
  const navigate = useNavigate();

  function handleCancel() {
    navigate("/scheme/asal-scheme");
  }
  const [fileUrl, setfileUrl] = useState(
    activeObjSchemes?.schIrrLicense ?? null
  );
  useEffect(() => {
    setfileUrl(activeObjSchemes?.schIrrLicense ?? null);
  }, [activeObjSchemes?.schIrrLicense]);

  const [fileUrlP, setfileUrlP] = useState(
    activeObjSchemes?.schPermitFile ?? null
  );
  useEffect(() => {
    setfileUrlP(activeObjSchemes?.schPermitFile ?? null);
  }, [activeObjSchemes?.schPermitFile]);


    const [fileCert, setfileCert] = useState(
      activeObjSchemes?.schIwuaRegCertFile ?? null
    );
    useEffect(() => {
      setfileCert(activeObjSchemes?.schIwuaRegCertFile ?? null);
    }, [activeObjSchemes?.schIwuaRegCertFile]);
  


  const onFinish = async (data) => {
    data.schId = activeObjSchemes?.schId ? activeObjSchemes?.schId : null;
    data.schCrops = Array.isArray(data?.schCrops)
      ? data?.schCrops.join(",")
      : data?.schCrops;
    data.schBlocks = Array.isArray(data?.schBlocks)
      ? data?.schBlocks.join(",")
      : data?.schBlocks;
    data.schSchemeType = "ASAL";
    data.schRegDate = normalizeDateToLocalYear(data?.schRegDate);
    data.schComplDate = normalizeDateToLocalYear(data?.schComplDate);

    data.schConstructionStartDate = normalizeDateToLocalYear(
      data?.schConstructionStartDate
    );
    data.schConstructionEndDate = normalizeDateToLocalYear(
      data?.schConstructionEndDate
    );
    data.schRevisedEndDate = normalizeDateToLocalYear(data?.schRevisedEndDate);
    data.schFsId = Array.isArray(data?.schFsId)
      ? data?.schFsId.join(",")
      : data?.schFsId;

    data.schPathwayId = Array.isArray(data?.schPathwayId)
      ? data?.schPathwayId.join(",")
      : data?.schPathwayId;

    data.schIrrigationTypeId = Array.isArray(data?.schIrrigationTypeId)
      ? data?.schIrrigationTypeId.join(",")
      : data?.schIrrigationTypeId;

    data.schWaterApplicationModesId = Array.isArray(
      data?.schWaterApplicationModesId
    )
      ? data?.schWaterApplicationModesId.join(",")
      : data?.schWaterApplicationModesId;

    data.schPermitFile = fileUrlP;
    data.schIrrLicense = fileUrl;
    data.schIwuaRegCertFile = fileCert;

    const res = await dispatch(
      save({
        ...data,
        url: "sch/scheme",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await form.resetFields();
      await handleCancel();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  useEffect(() => {
    form.setFieldsValue({
      ...activeObjSchemes,

      schConstructionStartDate: activeObjSchemes?.schConstructionStartDate
        ? dayjs(new Date(activeObjSchemes?.schConstructionStartDate))
        : null,
      schConstructionEndDate: activeObjSchemes?.schConstructionEndDate
        ? dayjs(new Date(activeObjSchemes?.schConstructionEndDate))
        : null,
      schRevisedEndDate: activeObjSchemes?.schRevisedEndDate
        ? dayjs(new Date(activeObjSchemes?.schRevisedEndDate))
        : null,
    });
  }, [activeObjSchemes, form]);

  const initialFormValues = {
    ...activeObjSchemes,
    schConstructionStartDate: activeObjSchemes?.schConstructionStartDate
      ? dayjs(new Date(activeObjSchemes?.schConstructionStartDate))
      : null,
    schConstructionEndDate: activeObjSchemes?.schConstructionEndDate
      ? dayjs(new Date(activeObjSchemes?.schConstructionEndDate))
      : null,
    schRevisedEndDate: activeObjSchemes?.schRevisedEndDate
      ? dayjs(new Date(activeObjSchemes?.schRevisedEndDate))
      : null,
  };

  useEffect(() => {
    if (activeObjSchemes?.schCrops) {
      form.setFieldsValue({
        schCrops: activeObjSchemes?.schCrops?.split(",")?.map((b) => b?.trim()),
      });
    }
    if (activeObjSchemes?.schFsId) {
      form.setFieldsValue({
        schFsId: activeObjSchemes?.schFsId?.split(",")?.map((b) => b?.trim()),
      });
    }
    if (activeObjSchemes?.schPathwayId) {
      form.setFieldsValue({
        schPathwayId: activeObjSchemes?.schPathwayId
          ?.split(",")
          .map((b) => b.trim()),
      });
    }

    if (activeObjSchemes?.schIrrigationTypeId) {
      form.setFieldsValue({
        schIrrigationTypeId: activeObjSchemes?.schIrrigationTypeId
          ?.split(",")
          .map((b) => b.trim()),
      });
    }
    if (activeObjSchemes?.schWaterApplicationModesId) {
      form.setFieldsValue({
        schWaterApplicationModesId: activeObjSchemes?.schWaterApplicationModesId
          ?.split(",")
          .map((b) => b.trim()),
      });
    }
  }, [activeObjSchemes, form]);

  const updateCategory = (size) => {
    if (size <= 100) return "Small";
    if (size > 100 && size <= 3000) return "Medium";
    if (size > 3000) return "Large";
    return "";
  };

  return (
    <div className="w-full ">
      <BreadCrumb
        breadcrumbs={[
          { title: "Asal schemes list", path: "/scheme/asal-scheme" },
          { title: "Asal Scheme Form" },
        ]}
      />
      <div className="white_card mt-[2.06rem]">
        <div className="form-add-h mb-[1.25rem]">
          {activeObjSchemes?.schId ? "Update Scheme" : "Register a new Scheme"}
        </div>
        <Divider />
        <div className="w-full  mt-[1.75rem]">
          <Form
            layout="vertical"
            ref={formRef}
            name="control-ref"
            onFinish={onFinish}
            className=""
            style={{
              maxWidth: "100%",
            }}
            form={form}
            initialValues={initialFormValues}
            onValuesChange={(changedValues, allValues) => {
              if (changedValues?.schLandSize !== undefined) {
                const categoryValue = updateCategory(changedValues.schLandSize);
                form?.setFieldsValue({ schSize: categoryValue });
              }
            }}
          >
            <div className="custom-title">Scheme Details</div>

            <Details form={form} fileUrl={fileUrl} setfileUrl={setfileUrl}   fileCert={fileCert} setfileCert={setfileCert}/>

            <div className="custom-title  mt-[3rem]">
              Operational information
            </div>
            <Operations form={form} />

            <div className="custom-title  mt-[3rem]">Land and Use</div>
            <LandUse form={form} />

            <div className="custom-title mt-[3rem]">Water</div>
            <Water form={form} fileUrl={fileUrlP} setfileUrl={setfileUrlP} />

            <div className="flex justify-between mt-[48px] ">
              <div className="justify-start"></div>
              <div className="justify-end flex items-center mb-[58px] gap-x-5">
                <div className="w-[150px]">
                  <button
                    type="button"
                    key="back"
                    onClick={handleCancel}
                    className="cstm-btn"
                  >
                    Cancel
                  </button>
                </div>

                <div className="w-[150px]">
                  <button
                    disabled={saving}
                    key="submit"
                    type="submit"
                    className="cstm-btn-2"
                  >
                    {saving ? (
                      <Spin />
                    ) : activeObjSchemes?.schId ? (
                      "Update"
                    ) : (
                      "Create"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};
export default AsalAdd;
